import axios from '../../axios-common';

const LOGGED_IN = 'session/LOGGED_IN';
const LOGGED_OUT = 'session/LOGGED_OUT';
const CHANGE_CRACHA = 'session/CHANGE_CRACHA';
const IS_PRODUCTION_DATABASE = 'seesion/IS_PRODUCTION_DATABASE';

const initialState = {
  currentUser: null,
  selectApelido: null,
  isProductionDatabase: null,
  permissoesMenu: [],
  permissoesBotao: []
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOGGED_IN: {
      return { ...state, currentUser: action.user };
    }
    case LOGGED_OUT:
      return { ...state, currentUser: null, selectApelido: null };
    case CHANGE_CRACHA:
      return { ...state, selectApelido: action.apelido };
    case IS_PRODUCTION_DATABASE:
      return { ...state, isProductionDatabase: action.database };
    default:
      return state;
  }
}

export function currentUser() {
  return (dispatch) => {
    return axios.get('api/user/currentUser')
      .then(res => dispatch({
        type: LOGGED_IN,
        user: res.data
      })).catch(() => dispatch({ type: LOGGED_OUT }));
  };
}

export function logIn(id, password) {
  const URL = `${axios.defaults.baseURL}/api/login`;
  return fetch(URL, {
    method: 'POST',
    mode: 'cors',
    body: JSON.stringify({ username: id, password }),
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  });
}

export function logOut() {
  return (dispatch) => {
    return new Promise((resolve) => {
      localStorage.removeItem('app.authToken');
      dispatch({ type: LOGGED_OUT });
      resolve();
    });
  };
}

export function getApelido(codUser) {
  return (dispatch) => {
    axios.get(`api/user/${codUser}/apelido`)
      .then((res) => {
        dispatch({
          type: CHANGE_CRACHA,
          apelido: res.data
        });
      });
  };
}

export function getConnectedDatabase() {
  return (dispatch) => {
    axios.get('/api/system/isProduction')
      .then((res) => {
        dispatch({
          type: IS_PRODUCTION_DATABASE,
          database: res.data
        });
      });
  };
}
